import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircleIcon, UsersIcon } from 'lucide-react';
export function NotificationPopups() {
  const [currentIndex, setCurrentIndex] = useState(-1); // -1 means hidden
  const notifications = [{
    type: 'traffic',
    title: 'Ahora mismo',
    message: 'Alguien de Florida está viendo esta guía',
    subtext: 'Entró hace 1 min',
    icon: <UsersIcon className="w-5 h-5 text-navy" data-id="element-147" />
  }, {
    type: 'whatsapp',
    title: 'WhatsApp',
    message: 'Nuevo mensaje',
    subtext: '"Hola, ¿me envías el ebook gratis?"',
    icon: <MessageCircleIcon className="w-5 h-5 text-white" data-id="element-148" />,
    iconBg: 'bg-whatsapp'
  }, {
    type: 'traffic',
    title: 'Hace 2 min',
    message: 'Alguien de Texas solicitó el ebook',
    subtext: 'Toca para escribir por WhatsApp',
    icon: <UsersIcon className="w-5 h-5 text-navy" data-id="element-149" />
  }, {
    type: 'whatsapp',
    title: 'WhatsApp',
    message: 'Nuevo mensaje',
    subtext: '"¿Qué seguro me conviene para mi familia?"',
    icon: <MessageCircleIcon className="w-5 h-5 text-white" data-id="element-150" />,
    iconBg: 'bg-whatsapp'
  }];
  useEffect(() => {
    // Start the cycle after a short delay
    const initialDelay = setTimeout(() => {
      setCurrentIndex(0);
    }, 3000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (currentIndex === -1) return;
    // Show notification for 5 seconds, then hide for 5 seconds before showing next
    const showDuration = 5000;
    const hideDuration = 5000;
    const hideTimer = setTimeout(() => {
      setCurrentIndex(-1); // Hide
      const nextTimer = setTimeout(() => {
        setCurrentIndex(prev => prev === -1 ? (currentIndex + 1) % notifications.length : prev);
      }, hideDuration);
      return () => clearTimeout(nextTimer);
    }, showDuration);
    return () => clearTimeout(hideTimer);
  }, [currentIndex, notifications.length]);
  const currentNotification = currentIndex !== -1 ? notifications[currentIndex] : null;
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-151">
      <AnimatePresence data-id="element-152">
        {currentNotification && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25
      }} className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 p-4 w-[300px] sm:w-[340px] pointer-events-auto" data-id="element-153">
            <div className="flex items-start gap-3" data-id="element-154">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${currentNotification.iconBg || 'bg-cream'}`} data-id="element-155">
                {currentNotification.icon}
              </div>
              <div className="flex-1 min-w-0" data-id="element-156">
                <div className="flex justify-between items-center mb-0.5" data-id="element-157">
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-158">
                    {currentNotification.title}
                  </p>
                </div>
                <p className="text-sm font-bold text-navy leading-tight mb-1" data-id="element-159">
                  {currentNotification.message}
                </p>
                <p className={`text-xs ${currentNotification.type === 'whatsapp' ? 'text-gray-600 italic' : 'text-gold-dark'}`} data-id="element-160">
                  {currentNotification.subtext}
                </p>
              </div>
            </div>
            <div className="mt-3 pt-2 border-t border-gray-100 text-center" data-id="element-161">
              <p className="text-[10px] text-gray-400" data-id="element-162">
                Notificaciones ilustrativas.
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}